import PropTypes from "prop-types"

import { HeaderTitle } from "../createTeeupGameplanStyles"

export const Header = ({ title, isDecided, suggestionsLength }) => {
  return (
    <HeaderTitle>
      {title}
      {/* QJ: no "Decided" badge/label anywhere in the build -- a decided
          suggestion just shows its title/value, no status label. */}
      {!isDecided && suggestionsLength > 0 && (
        <>
          ·{" "}
          <HeaderTitle $color="var(--darkBlue)">
            {suggestionsLength}{" "}
            {suggestionsLength > 1 ? "suggestions" : "suggestion"}
          </HeaderTitle>
        </>
      )}
    </HeaderTitle>
  )
}

Header.propTypes = {
  gameplanData: PropTypes.object,
}
